// ignore-string-externalization

/* eslint-disable import/prefer-default-export */

const monthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export function formatShortDate(date: $TSFixMe) {
  if (!(date instanceof Date)) {
    throw new Error('Argument must be a "Date" instance');
  }

  const day = `0${date.getDate()}`.slice(-2);
  const month = monthsShort[date.getMonth()];
  return `${month} ${day}, ${date.getFullYear()}`;
}
